import { render, staticRenderFns } from "./AIFlows.vue?vue&type=template&id=4f5c0580&scoped=true&"
import script from "./AIFlows.vue?vue&type=script&lang=js&"
export * from "./AIFlows.vue?vue&type=script&lang=js&"
import style0 from "./AIFlows.vue?vue&type=style&index=0&id=4f5c0580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c0580",
  null
  
)

export default component.exports